import { publishThreadDocumentsChanged } from "@/features/chat/documents/threadDocumentsEvents";

export function publishArtifactDocuments(threadId, blocks) {
  if (blocks?.some((block) => block?.type === "artifact_card")) {
    publishThreadDocumentsChanged(threadId);
  }
}
